/* eslint-disable react/no-danger */
import hydrate from 'next-mdx-remote/hydrate';

import { ViewWrapper, SinglePageWrapper, MDXContentWrapper } from '@/styles/index';
import Navbar from '@/components/Layout/Navbar';
// import Footer from '@/components/Layout/Footer';
import BaseCTA from '@/components/Layout/CTA';
import dynamic from 'next/dynamic';

import { getFiles, getFileBySlug, getAllFilesFrontMatter } from '@/lib/mdx';
import BlogLayout from '@/components/Layout/Blog';
import MDXComponents from '@/components/MDXComponents';
import HeadMeta from '@/components/HeadMeta';
import { useSession } from 'next-auth/client';
import AdSenseBanner from '@/components/AdSenseBanner';
import siteConfig from '../../siteConfig';

const Footer = dynamic(() => import('@/components/Layout/Footer'));

// https://search.google.com/test/rich-results

export default function Blog({ post, allPosts }) {
  const [session] = useSession();
  const { mdxSource, frontMatter } = post;
  const content = hydrate(mdxSource, {
    components: MDXComponents
  });

  const isProUser = session && session.user.isProUser === 'true';
  const isPremiumUser = session && session.user.isPremiumUser === 'true';
  const isSubscriptionUser = isProUser || isPremiumUser;
  const showAds = !session || !isSubscriptionUser;

  const breadCrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Guides',
        item: 'https://pollme.app/guides'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: frontMatter.title
      }
    ]
  };
  const description = frontMatter.summary ? { description: frontMatter.summary } : {};
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: frontMatter.title,
    wordCount: frontMatter.wordCount,
    name: frontMatter.title,
    ...description,
    datePublished: frontMatter.publishedAt, // '2015-02-05T08:00:00+08:00',
    dateModified: frontMatter.modifiedAt || frontMatter.publishedAt, // '2015-02-05T09:20:00+08:00',
    image: frontMatter.cover || siteConfig.siteBanner,
    // image: [
    //   'https://example.com/photos/1x1/photo.jpg',
    //   'https://example.com/photos/4x3/photo.jpg',
    //   'https://example.com/photos/16x9/photo.jpg'
    // ],
    author: {
      '@type': 'Organization',
      url: siteConfig.siteUrl,
      logo: siteConfig.siteFav,
      email: siteConfig.userEmail,
      name: siteConfig.siteTitleAlt
    },
    publisher: {
      '@type': 'Organization',
      name: siteConfig.siteTitleAlt,
      logo: {
        '@type': 'ImageObject',
        url: siteConfig.siteFav
      }
    }
  };
  return (
    <ViewWrapper>
      <HeadMeta
        title={`${frontMatter.title} – Pollme`}
        description={frontMatter.summary ? frontMatter.summary : null}
        image={frontMatter.image ? frontMatter.image : null}
        date={new Date(frontMatter.publishedAt).toISOString()}
        type="article"
      >
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadCrumbSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
        />
      </HeadMeta>
      <Navbar session={session} />
      <SinglePageWrapper>
        <MDXContentWrapper>
          <BlogLayout frontMatter={frontMatter}>{content}</BlogLayout>
        </MDXContentWrapper>
        {showAds && (
          <AdSenseBanner
            className="ads-block centered"
            slot="3434073627" // create footer
            format="auto"
            responsive="true"
          />
        )}
      </SinglePageWrapper>
      <BaseCTA />
      <Footer />
    </ViewWrapper>
  );
}

export async function getStaticPaths({ locales }) {
  const guides = await getFiles('guides');
  const cleanedSlugs = guides.map(p => p.replace(/\.mdx/, ''));
  const paths = [];
  for (const locale of locales) {
    for (const slug of cleanedSlugs) {
      paths.push({ params: { slug }, locale });
    }
  }
  return {
    paths,
    // paths: guides.map(p => ({
    //   params: {
    //     slug: p.replace(/\.mdx/, '')
    //   }
    // })),
    fallback: false
  };
}

export async function getStaticProps({ params, locale, defaultLocale }) {
  const post = await getFileBySlug('guides', params.slug, {
    locale,
    defaultLocale
  });
  const allPosts = await getAllFilesFrontMatter('guides');
  return { props: { post, allPosts } };
}
